import type {
    ParsedTimeSpan,
    TimeSpan,
} from "@figurepos/fgr-lib-business-logic/lib/common/dateTime/hours_of_operation_v2"
import { compact } from "@figurepos/fgr-lib-business-logic/lib/common/functional"
import { compareAsc, getDate, getMonth, getYear, isBefore, set } from "date-fns"

export const getRawTimeSpansFromParsed = (parsed: ParsedTimeSpan[]): TimeSpan[] => {
    return compact(
        parsed.map(p => {
            let date: any = null

            if (p.dayOfWeek) {
                date = p.dayOfWeek
            } else if (p.day && p.month && p.year) {
                date = `${p.day}.${p.month}.${p.year}`
            }

            if (date) {
                const neverOrAlways = p.never ? "x " : p.always ? "* " : ""
                const rangeString = (p.ranges || []).map(r => r.start + "-" + r.end).join(" ")
                return `${date} ${neverOrAlways}${rangeString}`.trim()
            }

            return null
        })
    )
}

export const isParsedTimeSpanRelatedToDate = (span: ParsedTimeSpan, date: Date): boolean => {
    if (
        (span.year != null && getYear(date) !== span.year) ||
        (span.month != null && getMonth(date) + 1 !== span.month) ||
        (span.day != null && getDate(date) !== span.day)
    ) {
        return false
    }

    return true
}

export const sortParsedSpans = (a: ParsedTimeSpan, b: ParsedTimeSpan) =>
    compareAsc(
        new Date(
            a.year || getYear(new Date()),
            (a.month || getMonth(new Date()) + 1) - 1,
            a.day || getDate(new Date())
        ),
        new Date(b.year || getYear(new Date()), (b.month || getMonth(new Date()) + 1) - 1, b.day || getDate(new Date()))
    )

export const isParsedSpanInPast = (p: ParsedTimeSpan, now: Date) =>
    p.year != null && p.month != null && p.day != null
        ? isBefore(
              set(now, {
                  year: p.year,
                  month: p.month - 1,
                  date: p.day,
              }),
              now
          )
        : false
